import { useEffect, useState } from "react";
import {
  getInterviewList,
  getInterviewListByYear,
  getNewsById,
  NewsResponse,
} from "../../../../../../api/news";

export const useRabbitFestivalInterview = () => {
  const [loading, setLoading] = useState(true);
  const [interview, setInterview] = useState<NewsResponse | null>(null);
  const [interviewId, setInterviewId] = useState<number>(0);
  const [interviewList, setInterviewList] = useState<NewsResponse[]>([]);
  const [topInterview, setTopInterview] = useState<NewsResponse>();
  const [year, setYear] = useState(new Date().getFullYear());
  const [isFirst, setIsFirst] = useState(true);

  const getList = async () => {
    const res = await getInterviewList();
    setTopInterview(res[0]);
    setTimeout(() => {
      setIsFirst(false);
    }, 50);
  };

  const getListByYear = async () => {
    try {
      const res = await getInterviewListByYear(year);
      const list =
        year === new Date().getFullYear() ? res.filter((_, i) => i !== 0) : res;
      setInterviewList(list);
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 50);
    }
  };

  useEffect(() => {
    setLoading(true);
    getListByYear();
  }, [year]);

  useEffect(() => {
    getList();
  }, []);

  const getInterview = async () => {
    if (!interviewId) return;
    setLoading(true);
    const res = await getNewsById(interviewId.toString());
    setInterview(res);
    setTimeout(() => {
      setLoading(false);
    }, 50);
  };

  useEffect(() => {
    getInterview();
  }, [interviewId]);

  return {
    // 인터뷰 페이지
    interview,
    setInterview,
    interviewId,
    setInterviewId,
    // 메인 인터뷰
    interviewList,
    topInterview,
    year,
    setYear,
    isFirst,
    loading,
  };
};
